// extracted by mini-css-extract-plugin
export var PartnersSection__item = "PartnersSection__item_QEMV6";